import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles((theme) => ({
  segmentsDotted: {
    border: '1px dashed #C0C0CF',
    borderRadius: '4px',
    width: 'auto',
    margin: '0px 0',
    padding: '10px 30px',
    '@media screen and (max-width: 768px)': {
      margin: '15px',
      padding: '15px',
    }
  },
  card: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    margin: '0 40px'
  },
  table: {
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '1000px',
      overflowX: 'auto'
    },
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#4277C6',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '12px',
      padding: '12px 8px',
      '& .MuiTableSortLabel-root': {

      },
    },
    '& .MuiTableBody-root': {
      paddingLeft: '20px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777',
      padding: '12px 8px'
    },
    '& .MuiSvgIcon-root': {
      fill: '#4B6FC2',
      fontSize: '24px'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fontSize: '14px',
      margin: '0',
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    },
  },
  paginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  toolbarContainer: {
    borderBottom: '1px solid #D0E9FF'
  },
  selectedItemsTable: {
    overflowX: 'auto',
    minWidth: '600px',
    '& .MuiTableRow-root': {
      verticalAlign: 'top'
    },
    '& .MuiTableCell-body': {
      color: '#32324D'
    }
  },
  quoteSummaryTable: {
    backgroundColor: '#F4F7FF',
    borderWidth: '0',
    borderRadius: '4px',
  },
  quoteSummaryTableImage: {
    filter: 'drop-shadow(0px 1px 4px rgba(33, 33, 52, 0.1))',
    borderRadius: '4px',
    maxHeight: '60px',
    width: '100%',
    minWidth: '60px',
    objectFit: 'contain',
    padding: '5px'
  },
  quoteGroupDotted: {
    border: '1px dashed #C0C0CF',
    borderRadius: '4px',
    width: 'auto',
    marginBottom: '12px',
    padding: '10px 10px 0',
    '@media screen and (max-width: 768px)': {
      margin: '15px',
      padding: '15px',
    },
    '& .MuiAutocomplete-popupIndicator': {
      marginRight: '-8px'
    },
    '& .MuiSelect-icon': {
      right: '0'
    },
  },
  blueCell: {
    backgroundColor: '#E7F0FF',
    borderTop: '1px solid #D0E9FF',

    '&.MuiTableCell-root': {
      tableLayout: 'auto',
      maxWidth: '1000px',
    },
  },
  noBorders: {
    '& > *': {
      borderBottom: 'unset'
    },
  },
  customBadge: {
    marginLeft: '10px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: '1rem',
      marginLeft: '0'
    },
  },
  filterBtn: {
    padding: '7px 15px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));
